namespace advisorop.components.servicer {

    export class OrionHighCashModelMonitorController {
        dgData: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        showNeto: boolean = true;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        mvDate: Date = null;

        // grid instance
        dgInst: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#orionHighCashMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "OrionHighCashModelMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.dgData",
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                //width: 1000,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: ""
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                onInitialized: function (e: any) {
                    //console.log('Initialising...');
                    this.dgNegCashMonitor = e.component;
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "accountId", caption: "", cellTemplate: "colActions", width: 30 },
                    { dataField: "representativeName", caption: "Representative Name", width: 100 },
                    { dataField: "accountName", caption: "Account Name", width: 80 },
                    { dataField: "accountNumber", caption: "Account Number", width: 120 },
                    { dataField: "custodian", caption: "Custodian", width: 80 },
                    { dataField: "model", caption: "Model", width: 120 },
                    { dataField: "value", caption: "Total Value", format: { type: "currency" }, width: 80 },
                    { dataField: "managedValue", caption: "Managed Value", format: { type: "currency" }, width: 80 },
                    { dataField: "excludedValue", caption: "Excluded Value", format: { type: "currency" }, width: 80 },
                    { dataField: "setAsideCashActual", caption: "Set Aside Cash Actual", format: { type: "currency" }, width: 80 },
                    { dataField: "targetCash", caption: "Target Cash ($)", format: { type: "currency" }, width: 80 },
                    { dataField: "currentCash", caption: "Current Cash ($)", format: { type: "currency" }, width: 80 },
                    { dataField: "cashNeedAmount", caption: "Cash Need ($)", format: { type: "currency" }, width: 80 },
                    {
                        dataField: "cashNeedPercent",
                        caption: "Cash Need (%)",
                        format: { type: "percent" },
                        width: 80,
                        calculateCellValue: (rowData) => {
                            return rowData.cashNeedPercent / 100;
                        }
                    }
                ],
                onCellPrepared: this.oncp
            };

        }

        /**
         * report: AssetAllocation, Holdings, Performance, Transactions
         * level: will always be A-account or S-sleeve account
         * */
        openReport = (report: string, level: string, account: any) => {
            console.log(`Report: ${report} Level ${level}, account: ${account}`);
            this.servicerService.calculateOrionParamsAsync(level, account.accountId).then(params => {
                this.servicerService.openOrionReport(report, params);
            });
        }

        oncp = function (e: any) {
            if (e.rowType === 'data' && e.column.command === 'expand') {
                if (!(e.row.data && e.row.data.sleeves && e.row.data.sleeves.length > 0)) {
                    e.cellElement.removeClass('dx-datagrid-expand');
                    e.cellElement.empty();
                }
            }
        }

        loadDgData() {

            this.mvDate = null;
            let rez: any;
            this.isInitializing = true;
            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                rez = this.servicerService.getOrionHighCashModelMonitorData(this.advisoryFirmId);
            }

            rez.then(response => {
                this.dgData = response.data;
                if (this.dgData.length > 0) {
                    this.issuesCount = this.dgData.length;
                }
                this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadDgData();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
            for (var key in evt) {
                //if (key === "advisoryFirmId" && this.advisoryFirmId) {
                //    console.log("Cash Monitor details data: ");
                //    console.log(this.dgData);
                //}
            }
        };
    }


    class OrionHighCashModelMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = OrionHighCashModelMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/orion-high-cash-model-monitor.html";
        }
    }
    angular.module(Constants.APP).component("orionHighCashModelMonitor", new OrionHighCashModelMonitor());

}